'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var shelfItemShape = _react.PropTypes.shape({
  id: _react.PropTypes.number,
  metadataId: _react.PropTypes.string,
  shelf: _react.PropTypes.string,
  privateItem: _react.PropTypes.bool,
  dateAdded: _react.PropTypes.string
});

exports.default = shelfItemShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/shelfItemShape.js
// module id = 1382
// module chunks = 1